import React from 'react';

// ── Types ──────────────────────────────────────────────────────────────────────

interface ContactItem {
  icon: string;
  label: string;
  lines: string[];
  href?: string;
  accent: string;
}

interface SocialLink {
  label: string;
  href: string;
  icon: React.ReactNode;
  color: string;
}

// ── Data ───────────────────────────────────────────────────────────────────────

const CONTACT_ITEMS: ContactItem[] = [
  {
    icon: '📱',
    label: 'Phone',
    lines: ['+91 98248 27317', '+91 82004 32810'],
    href: 'tel:+919824827317',
    accent: '#10b981',
  },
  {
    icon: '✉️',
    label: 'Email',
    lines: ['prajapati.piyush16@gmail.com'],
    href: 'mailto:prajapati.piyush16@gmail.com',
    accent: '#06b6d4',
  },
  {
    icon: '📍',
    label: 'Location',
    lines: ['Gandhinagar, Gujarat, India'],
    accent: '#f59e0b',
  },
  {
    icon: '🕐',
    label: 'Availability',
    lines: ["Anytime"],
    // lines: ['Mon – Sat, 9 AM – 7 PM IST'],
    accent: '#8b5cf6',
  },
];

const SOCIAL_LINKS: SocialLink[] = [
  {
    label: 'GitHub',
    href: 'https://github.com/piyushbhai',
    color: '#e2e8f0',
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/piyush-prajapati-fullstackarchitect',
    color: '#0a66c2',
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: 'LeetCode',
    href: 'https://leetcode.com/piyushprajapati16/',
    color: '#ffa116',
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104 5.35 5.35 0 0 0-.125.513 5.527 5.527 0 0 0 .062 2.362 5.83 5.83 0 0 0 .349 1.017 5.938 5.938 0 0 0 1.271 1.818l4.277 4.193.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523 2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382 1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382 1.38 1.38 0 0 0-1.38-1.382z" />
      </svg>
    ),
  },
  {
    label: 'GitLab',
    href: 'https://gitlab.com/piyushprajapati',
    color: '#fc6d26',
    icon: (
      <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
        <path d="M4.845.904C4.605.904 4.4 1.088 4.354 1.32L.014 17.88c-.06.25.04.51.26.645l11.741 7.456a.51.51 0 00.54 0l11.741-7.456c.22-.135.32-.395.26-.645L20.216 1.32C20.17 1.088 19.965.904 19.725.904h-4.46L13.5 10.48 12 5.97l-1.5 4.51L8.735.904H4.845z" />
      </svg>
    ),
  },
];

// ── Component ──────────────────────────────────────────────────────────────────

const ContactCTA: React.FC = () => (
  <section id="contact" className="relative py-28 bg-[#0d0d14] overflow-hidden">

    {/* Ambient glows */}
    <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-[140px] pointer-events-none" />
    <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-cyan-500/5 rounded-full blur-[120px] pointer-events-none" />

    <div className="relative z-10 max-w-5xl mx-auto px-6">

      {/* ── Header ── */}
      <div className="mb-16">
        <p className="text-emerald-400 font-mono text-sm tracking-widest uppercase mb-3">
          Let's Connect
        </p>
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4">Get In Touch</h2>
        <p className="text-slate-400 max-w-xl leading-relaxed">
          Available for Full-time roles, Remote Roles and Technical consulting.
          Let's build something great.
        </p>
      </div>

      {/* ── Availability banner ── */}
      <div
        className="flex flex-wrap items-center gap-4 px-6 py-4 rounded-2xl border mb-14"
        style={{
          background: 'linear-gradient(135deg, #10b98110 0%, #06b6d408 100%)',
          borderColor: '#10b98128',
        }}
      >
        <span className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-emerald-300 font-bold text-sm">Open to Opportunities</span>
        </span>
        <span className="text-slate-600 hidden sm:block">·</span>
        <span className="text-slate-400 text-sm">
          Actively seeking <span className="text-white font-semibold">Senior Architect / Lead Full Stack</span> roles
        </span>
        <span className="text-slate-600 hidden sm:block">·</span>
        <span className="text-slate-400 text-sm">Remote &amp; On-site</span>
      </div>

      {/* ── Contact cards grid ── */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {CONTACT_ITEMS.map((item) => (
          item.href ? (
            <a
              key={item.label}
              href={item.href}
              className="group flex flex-col gap-4 p-6 rounded-2xl bg-[#13131e] border border-slate-800 hover:border-slate-600 transition-all duration-200 hover:-translate-y-1"
              style={{ '--accent': item.accent } as React.CSSProperties}
            >
              {/* Icon bubble */}
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl shrink-0 transition-transform duration-200 group-hover:scale-110"
                style={{
                  background: `${item.accent}18`,
                  border: `1px solid ${item.accent}30`,
                }}
              >
                {item.icon}
              </div>
              <div>
                <div
                  className="text-xs font-mono uppercase tracking-widest mb-2"
                  style={{ color: item.accent }}
                >
                  {item.label}
                </div>
                {item.lines.map((line) => (
                  <div
                    key={line}
                    className="text-sm font-semibold text-slate-300 group-hover:text-white transition-colors leading-relaxed"
                  >
                    {line}
                  </div>
                ))}
              </div>
            </a>
          ) : (
            <div
              key={item.label}
              className="flex flex-col gap-4 p-6 rounded-2xl bg-[#13131e] border border-slate-800"
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl shrink-0"
                style={{
                  background: `${item.accent}18`,
                  border: `1px solid ${item.accent}30`,
                }}
              >
                {item.icon}
              </div>
              <div>
                <div
                  className="text-xs font-mono uppercase tracking-widest mb-2"
                  style={{ color: item.accent }}
                >
                  {item.label}
                </div>
                {item.lines.map((line) => (
                  <div key={line} className="text-sm font-semibold text-slate-300 leading-relaxed">
                    {line}
                  </div>
                ))}
              </div>
            </div>
          )
        ))}
      </div>

      {/* ── Social links ── */}
      <div className="mb-14">
        <p className="text-xs font-mono text-slate-500 uppercase tracking-widest mb-5">
          Find me on
        </p>
        <div className="flex flex-wrap gap-3">
          {SOCIAL_LINKS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-[#13131e] border border-slate-800 hover:border-slate-600 transition-all duration-200 hover:-translate-y-0.5"
            >
              <span className="text-slate-500 group-hover:text-white transition-colors duration-200">
                {s.icon}
              </span>
              <span className="text-sm font-semibold text-slate-400 group-hover:text-white transition-colors duration-200">
                {s.label}
              </span>
              <span className="text-slate-700 text-xs group-hover:text-slate-400 transition-colors duration-200 ml-auto">↗</span>
            </a>
          ))}
        </div>
      </div>

      {/* ── What I can help with ── */}
      <div className="grid sm:grid-cols-3 gap-4 mb-14">
        {[
          {
            icon: '🏗',
            title: 'Architecture Consulting',
            desc: 'System design reviews, scalability audits, and microservices migration planning.',
          },
          {
            icon: '🚀',
            title: 'Full Stack Development',
            desc: 'End-to-end MERN / Next.js applications from MVP to production-ready scale.',
          },
          {
            icon: '🧑‍🏫',
            title: 'Tech Mentorship',
            desc: 'Code reviews, developer training, and engineering best practices.',
          },
        ].map((item) => (
          <div
            key={item.title}
            className="p-5 rounded-2xl bg-[#13131e] border border-slate-800 hover:border-emerald-500/20 transition-colors duration-200"
          >
            <span className="text-3xl block mb-3">{item.icon}</span>
            <div className="font-bold text-white text-sm mb-2">{item.title}</div>
            <p className="text-xs text-slate-400 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* ── CTA strip ── */}
      <div
        className="flex flex-col sm:flex-row items-center justify-between gap-6 px-8 py-7 rounded-2xl border"
        style={{
          background: 'linear-gradient(135deg, #10b98108 0%, #06b6d406 100%)',
          borderColor: '#10b98120',
        }}
      >
        <div>
          <div className="text-xl font-black text-white mb-1">Ready to work together?</div>
          <div className="text-slate-400 text-sm">
            Drop me an email or call — I typically respond within a few hours.
          </div>
        </div>
        <div className="flex flex-wrap gap-3 shrink-0">
          <a
            href="mailto:prajapati.piyush16@gmail.com"
            className="flex items-center gap-2 px-6 py-3 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-sm transition-all duration-200 hover:shadow-[0_0_28px_rgba(16,185,129,0.4)]"
          >
            ✉️ Send Email
          </a>
          <a
            href="tel:+919824827317"
            className="flex items-center gap-2 px-6 py-3 rounded-xl border border-slate-700 hover:border-emerald-500/40 text-slate-300 hover:text-emerald-400 font-semibold text-sm transition-all duration-200"
          >
            📱 Call Now
          </a>
        </div>
      </div>

    </div>
  </section>
);

export default ContactCTA;


// import React, { useState } from 'react';

// interface FormState {
//   name: string;
//   email: string;
//   subject: string;
//   message: string;
// }

// const ContactCTA: React.FC = () => {
//   const [form, setForm] = useState<FormState>({
//     name: '',
//     email: '',
//     subject: '',
//     message: '',
//   });

//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     // Wire up to your API / EmailJS / Formspree here
//     console.log('Form submitted:', form);
//   };

//   return (
//     <section id="contact" className="py-28 bg-[#0d0d14]">
//       <div className="max-w-5xl mx-auto px-6">
//         {/* Header */}
//         <div className="mb-16">
//           <p className="text-emerald-400 font-mono text-sm tracking-widest uppercase mb-3">
//             Let's Connect
//           </p>
//           <h2 className="text-4xl md:text-5xl font-black text-white">Get In Touch</h2>
//           <p className="text-slate-400 mt-3 max-w-xl">
//             Available for freelance projects, full-time roles, and technical consulting. Let's build
//             something great.
//           </p>
//         </div>

//         <div className="grid md:grid-cols-5 gap-10">
//           {/* Contact info */}
//           <div className="md:col-span-2 space-y-6">
//             {[
//               {
//                 icon: '📱',
//                 label: 'Phone',
//                 lines: ['+91 98248 27317', '+91 82004 32810'],
//                 href: 'tel:+919824827317',
//               },
//               {
//                 icon: '✉️',
//                 label: 'Email',
//                 lines: ['prajapati.piyush16@gmail.com'],
//                 href: 'mailto:prajapati.piyush16@gmail.com',
//               },
//               {
//                 icon: '📍',
//                 label: 'Location',
//                 lines: ['Gujarat, India'],
//                 href: undefined,
//               },
//             ].map((item) => (
//               <a
//                 key={item.label}
//                 href={item.href ?? '#'}
//                 className={`flex items-start gap-4 p-5 rounded-xl bg-[#13131e] border border-slate-800 transition-all duration-200 group ${
//                   item.href ? 'hover:border-emerald-500/30 cursor-pointer' : 'cursor-default'
//                 }`}
//               >
//                 <span className="text-2xl mt-0.5">{item.icon}</span>
//                 <div>
//                   <div className="text-xs font-mono text-slate-500 uppercase tracking-wider mb-1">
//                     {item.label}
//                   </div>
//                   {item.lines.map((l) => (
//                     <div
//                       key={l}
//                       className="text-sm font-semibold text-slate-300 group-hover:text-white transition-colors"
//                     >
//                       {l}
//                     </div>
//                   ))}
//                 </div>
//               </a>
//             ))}

//             {/* Social links */}
//             <div className="flex gap-3">
//               {[
//                 { label: 'GitHub', href: 'https://github.com/' },
//                 { label: 'LinkedIn', href: 'https://linkedin.com/' },
//                 { label: 'LeetCode', href: 'https://leetcode.com/' },
//               ].map((s) => (
//                 <a
//                   key={s.label}
//                   href={s.href}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="flex-1 text-center py-2.5 rounded-lg border border-slate-800 hover:border-emerald-500/40 text-slate-400 hover:text-emerald-400 text-xs font-semibold font-mono transition-all duration-200"
//                 >
//                   {s.label}
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* Form */}
//           <div className="md:col-span-3">
//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div className="grid sm:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-xs font-mono text-slate-500 uppercase tracking-wider mb-1.5">
//                     Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={form.name}
//                     onChange={handleChange}
//                     placeholder="John Doe"
//                     required
//                     className="w-full bg-[#13131e] border border-slate-800 rounded-lg px-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-emerald-500/60 focus:ring-1 focus:ring-emerald-500/20 transition-all"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-xs font-mono text-slate-500 uppercase tracking-wider mb-1.5">
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={form.email}
//                     onChange={handleChange}
//                     placeholder="john@company.com"
//                     required
//                     className="w-full bg-[#13131e] border border-slate-800 rounded-lg px-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-emerald-500/60 focus:ring-1 focus:ring-emerald-500/20 transition-all"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-xs font-mono text-slate-500 uppercase tracking-wider mb-1.5">
//                   Subject
//                 </label>
//                 <input
//                   type="text"
//                   name="subject"
//                   value={form.subject}
//                   onChange={handleChange}
//                   placeholder="Project Inquiry / Job Opportunity"
//                   className="w-full bg-[#13131e] border border-slate-800 rounded-lg px-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-emerald-500/60 focus:ring-1 focus:ring-emerald-500/20 transition-all"
//                 />
//               </div>
//               <div>
//                 <label className="block text-xs font-mono text-slate-500 uppercase tracking-wider mb-1.5">
//                   Message
//                 </label>
//                 <textarea
//                   name="message"
//                   value={form.message}
//                   onChange={handleChange}
//                   rows={5}
//                   placeholder="Tell me about your project..."
//                   required
//                   className="w-full bg-[#13131e] border border-slate-800 rounded-lg px-4 py-3 text-sm text-white placeholder-slate-600 focus:outline-none focus:border-emerald-500/60 focus:ring-1 focus:ring-emerald-500/20 transition-all resize-none"
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="w-full py-3.5 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-black font-bold text-sm tracking-wide transition-all duration-200 hover:shadow-[0_0_30px_rgba(16,185,129,0.35)]"
//               >
//                 Send Message →
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactCTA;
